window.$ = jQuery;
import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
const bowser = require('bowser');
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

if(bowser.msie === true) {
	$('body').addClass('ie');
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}
if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	$(document).ready(function(){
		window.addEventListener("orientationchange", function(){
			location.reload();
		});
	});
}

$(window).on('load resize',function(){
	if(r.state()()){
		$('body').addClass('mobile');
	}else{
		$('body').removeClass('mobile');
		document.querySelector("meta[name='viewport']").setAttribute("content", 'width=1200px');
	}
})
.on('load',function(){
	if(!r.state()() || bowser.tablet === true){
		document.querySelector("meta[name='viewport']").setAttribute("content", 'width=1200px');
	}
});
/* ===============================================
SP Navi
=============================================== */
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
// const totop = new ToTop('#totop',100,400);
// totop.exec();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
(function($){
	$(function(){
		$('.js-accordion-trigger').each(function(){
			var accordion = new Accordion(this);
			accordion.exec();
		});
	});
})(jQuery);
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });
//
(function($) {
$(function(){
	const sphide_lead = $('.sp_hide');
	$('.js--toplead_more').on('click',function(ev){
		ev.preventDefault();
		let _this = $(this);
		if(sphide_lead.css('display') === 'block'){
			sphide_lead.slideUp('400', function() {
				_this.html('&gt;&nbsp;MORE');
			});
		}else{
			sphide_lead.slideDown('400', function() {
				_this.html('&gt;&nbsp;CLOSE');
			});
		}
	});
});
})(jQuery);

/* ===============================================
swiper
=============================================== */
(function($) {
	$(function(){
		if($(".swiper-container").length){
			var mySwiper = new Swiper('.swiper-container', {
				speed: 800,
				autoplay:4000,
				effect:"fade",
				loop:true,
			});
		}
	});
})(jQuery);
/* ===============================================
map
=============================================== */
(function($) {
	$(function(){
		if($("#mapimg").length){
			var imgY = $("#mapimg").offset().top;
			$(window).on("scroll",function(){
				var scrl = $("body").scrollTop();
				// console.log(imgY );
				// console.log(scrl );
				if(scrl+50 > imgY){
					$("#mapimg").addClass("fixed");
				}else{
					$("#mapimg").removeClass("fixed");
				}
			});
		}
	});
})(jQuery);

/* ===============================================
works
=============================================== */
(function($){
	$(function(){
		if($(".works_list").length){
			$(".works_list__item").heightLine({
				minWidth:481
			});
		}
	});
})(jQuery);

/* ===============================================
map
=============================================== */
(function($) {
$(function(){
	if($('.map_point').length){
		//各要素からデータ配列を作成
		var data = [];
		$('.map_point').each(function(){
			var this_data;
			var desc = $(this).find('.shop_desc');

			var id = $(this).attr('id'),
				lat = $(this).data('lat'),
				lng = $(this).data('lng'),
				title = $(this).find('.map_point__name').text(),
				cat = $(this).find('.map_point__category').text(),
				place = $(this).find('.arrow_circle').text(),
				comment = $(this).find('.comment').text();

			if(lat !== '' && lng !==''){
				this_data = {
					'id':id,
					'lat':lat,
					'lng':lng,
					'title':title,
					'cat':cat,
					'place':place,
					'comment':comment
				};
				data.push(this_data);
			}
		});


		/* ===============================================
		mapの初期表示
		=============================================== */
		var currentInfoWindow;
		var markerClusterer = null;
		var map = null;
		var op = {
			zoom:12,
			center:new google.maps.LatLng(35.015077,135.737576),
			mapTypeId:google.maps.MapTypeId.ROADMAP
		};
		map = new google.maps.Map(document.getElementById("map_canvas"),op);

		//カラー設定
		var mapstyle = [
			{
				featureType: "all",
				elementType: "all",
				stylers: [
				{ saturation: -100 }
				]
			},
			{
				featureType: "all",
				elementType: "labels",
				stylers:[
				{ visibility: "on" } //道路名
				]
			},
			{
				featureType: "administrative",
				elementType: "all",
				stylers: [
				{ visibility: "on" }
				]
			},
			{
				featureType: "landscape",
				elementType: "all",
				stylers: [
				{ visibility: "on" }
				]
			},
			{
				featureType: "transit",
				elementType: "all",
				stylers: [
				{ visibility: "on" }
				]
			}
		];
		var colorName = 'myname';
		//デザイン設定と地図タイプの名前を反映
		map.mapTypes.set(colorName, new google.maps.StyledMapType(mapstyle, { name: colorName }));
		map.setMapTypeId(colorName);

		/* ===============================================
		marker出力
		=============================================== */
		var markers = [];
		var tmp = [];

		_.each(data,function(item,index){
			var obj = {
				position:new google.maps.LatLng(item.lat,item.lng),
				map:map,
				id:item.id,
				title:item.title,
				icon:"../wp/wp-content/themes/shubisha/assets/images/"+item.id+".png"
				//icon:ここにアイコンを指定する
			};
			var marker = new google.maps.Marker(obj);

			markers.push(marker);//markerごとの処理用配列
			tmp.push(item);

			/* ===============================================
			クリック系イベント
			=============================================== */
			//吹き出し内のhtml
			var inner = "<article class=\"mapinner\" style='width:380px;'><h2>"+item.title+"<small>"+item.cat+"</small></h2><p class='place'>"+item.place+"</p><p>"+item.comment+"</p></article>";
			// var inner = "<article class=\"mapinner\" style='width:400px;'><h2 class='serif'>"+item.title+"</h2></article>";

			//マップのクリックイベントに吹き出しを開く機能をバインド
			google.maps.event.addListener(markers[index], 'click', function(event) {
				if (currentInfoWindow) {
					currentInfoWindow.close();
				}
				var infoWnd	= new google.maps.InfoWindow({content: inner, maxWidth: 600});
				infoWnd.open(marker.getMap(), marker);
				currentInfoWindow = infoWnd;
				//中心に位置を修正する
				this.map.setCenter(marker.getPosition());
			});

			//ボタンクリックで画面移動して対応したmarkerを開く
			var clickID = "#" + item.id;


			$(clickID).click(function(){
				var HashOffset = $('#map_canvas').offset().top;
				google.maps.event.trigger(markers[index], 'click');
				map.setZoom(17);
				//クリック時にマップの位置まで移動させる。
				$("html,body").animate({
					scrollTop: HashOffset - 86
				}, 600);
				return false;
			});
		});

		/* ===============================================
		初期表示時の位置を調整
		=============================================== */
		// マーカーが1つであれば、そこへフォーカスをあてる
		// マーカーが０であれば、何も処理しない。
		// 1つ以上であれば、マーカーがマップ内に包含されるまで縮尺を下げる
		if (markers.length == 1) {
			map.setCenter(markers[0].getPosition());
			map.setZoom(14);
			var infowindow = new google.maps.InfoWindow({content: inner });
			infowindow.open(map, marker);
		}
		if (markers.length > 0){
			var bounds = new google.maps.LatLngBounds();
			for (var i in markers) {
				// 緯度経度を取得
				var latlng = markers[i].getPosition();
				// 検索結果地が含まれるように範囲を拡大
				bounds.extend(latlng);
			}
			map.fitBounds(bounds);
		}
	}
});
})(jQuery);


/* ===============================================
#	shide
=============================================== */
(function($) {
$(function(){
	$(".js-more").on("click",function(){
		$(this).next(".more").slideToggle();
	});
});
})(jQuery);



// WEBPACK FOOTER //
// ./js/scripts/main.js